import { SvgIcon, SvgIconProps } from "@mui/material";

const PerformanceIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <path d="M7.09091 12.8182H3.81818C3.32727 12.8182 3 13.1455 3 13.6364V20.1818C3 20.6727 3.32727 21 3.81818 21H7.09091C7.58182 21 7.90909 20.6727 7.90909 20.1818V13.6364C7.90909 13.1455 7.58182 12.8182 7.09091 12.8182ZM20.1818 9.54545H16.9091C16.4182 9.54545 16.0909 9.87273 16.0909 10.3636V20.1818C16.0909 20.6727 16.4182 21 16.9091 21H20.1818C20.6727 21 21 20.6727 21 20.1818V10.3636C21 9.87273 20.6727 9.54545 20.1818 9.54545ZM13.6364 3H10.3636C9.87273 3 9.54545 3.32727 9.54545 3.81818V20.1818C9.54545 20.6727 9.87273 21 10.3636 21H13.6364C14.1273 21 14.4545 20.6727 14.4545 20.1818V3.81818C14.4545 3.32727 14.1273 3 13.6364 3Z" fill="currentColor" />

  </SvgIcon>
);

export default PerformanceIcon;
